export var LazyModelChoiceFieldEvents;
(function (LazyModelChoiceFieldEvents) {
    LazyModelChoiceFieldEvents["ValueChanged"] = "lazy-model-choice-field-value-changed";
})(LazyModelChoiceFieldEvents || (LazyModelChoiceFieldEvents = {}));
